import apiClient from "../common/apiClient";

export default class FeeReceiptController {
  async GetGridData(token) {
    try {
       return await apiClient.get("/getReceiptGrid", {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }

  async GetReceiptId(id, token) {
    try {
      return await apiClient.get("/getReceiptData/" + id, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }
  async DeleteReceiptById(id, token) {
    try {
      return await apiClient.get("/deleteReceipt/" + id, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }
  async CreateReceipt(data, token) {
    try {
      return await apiClient.post("/generateReceipt", data, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }
  async SendPDFMail(id, token) {
    try {
      return await apiClient.get("/mailReceipt/" + id, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }
  async GetMemberData(data, token) {
    try {
      return await apiClient.get("/getMemberDetails/" + data, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }
}